import Vue from 'vue'
import Router from 'vue-router'
// import Home from '@/components/Home'
import AnimalDonation from '@/components/AnimalDonation'
import Nomad from '../components/Nomad.vue'
import store from '../store'
// import Listing from '@/components/listing'
import {nginxTags} from '../assets/js/nginxTagsRedirection'
import getLastPage from '@/assets/js/getLastPage'
import LandingPage from '@/components/LandingPage'

const getSelectedCountry = localStorage.getItem('tss-v2__selectedCountryAddress')
const isSelectedCountryGlobal = getSelectedCountry ? parseInt(JSON.parse(getSelectedCountry).value.countryId) !== 99 : false

Vue.use(Router)

var $ = require('jquery')
window.jQuery = $

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: LandingPage
    },
    {
      path: '/animal-donation',
      name: 'AnimalDonation',
      component: AnimalDonation
    },
    {
      path: '/nomad',
      name: 'Nomad',
      component: Nomad
    },
    {
      path: '/:category(men|women|kids|sneakers)',
      name: 'home',
      component: () => import(/* webpackChunkName: "Home" */ '@/components/Home.vue'),
      props: route => ({ category: route.params.category })
    },
    {
      path: '/winter-collection',
      name: 'WinterCollection',
      component: () => import(/* webpackChunkName: "WinterCollection" */ '@/components/winterCollection')
    },
    {
      path: '/stores-near-me',
      name: 'StoreLocator',
      component: () => import(/* webpackChunkName: "StoreLocator" */ '@/components/StoreLocator/storeLocator'),
      beforeEnter: (to, from, next) => {
        if (isSelectedCountryGlobal) {
          next({
            path: '/'
          })
        } else {
          next()
        }
      }
    },
    {
      path: '/year-in-review',
      name: 'YearInReview',
      component: () => import(/* webpackChunkName: "YearInReview" */ '@/components/yearInReview')
    },
    {
      path: '/getnotified',
      name: 'GetNotified',
      component: () => import(/* webpackChunkName: "YearInReview" */ '@/components/GetNotified')
    },
    {
      path: '/orders/details/:id',
      name: 'Order Details',
      component: () => import(/* webpackChunkName: "Order Details" */ '@/components/common/orderDetails'),
      meta: { requiresAuth: true }
    },
    {path: '/exclusive', redirect: '/membership'},
    /* listing route redirect */
    {
      path: '/mobile-covers',
      name: 'mobile-covers',
      component: () => import(/* webpackChunkName: "Mobile Covers" */ '@/components/mobile-covers')
    },
    {
      path: '/search',
      name: 'search',
      component: () => import(/* webpackChunkName: "search" */ '@/components/search')
    },
    {
      path: '/about-us',
      name: 'about',
      component: function (resolve) {
        require(['@/components/about.vue'], resolve)
      }
    },
    {
      path: '/investor-relation',
      name: 'Investor-relation',
      component: function (resolve) {
        require(['@/components/investorRelation.vue'], resolve)
      }
    },
    {
      path: '/faqs',
      name: 'faqs',
      component: () => import(/* webpackChunkName: "faq" */ '@/components/faqs')
    },
    {
      path: '/sitemap',
      name: 'sitemap',
      component: () => import(/* webpackChunkName: "sitemap" */ '@/components/sitemap')
    },
    {
      path: '/nps-feedback',
      name: 'feedback',
      component: () => import(/* webpackChunkName: "feedback" */ '@/components/Feedback')
    },
    {
      path: '/privacy-policy',
      name: 'privacyPolicy',
      component: () => import(/* webpackChunkName: "privacyPolicy" */ '@/components/privacyPolicy')
    },
    {
      path: '/generate-sitemap-html',
      name: 'sitemapHTML',
      component: () => import(/* webpackChunkName: "privacyPolicy" */ '@/components/sitemapHtml')
    },
    {
      path: '/avengers-endgame-sale',
      name: 'avengersale',
      component: () => import(/* webpackChunkName: "avengerSale" */ '@/components/avengers-sale')
    },
    {
      path: '/offers',
      name: 'offers',
      component: () => import(/* webpackChunkName: "offers" */ '@/components/offers')
    },
    {
      path: '/terms-and-conditions',
      name: 'termsconditions',
      component: () => import(/* webpackChunkName: "termsConditions" */ '@/components/termsConditions')
    },
    {
      path: '/gift-voucher',
      name: 'giftvoucher',
      component: () => import(/* webpackChunkName: "giftVoucher" */ '@/components/giftvoucher')
    },
    // {
    //   path: '/souled-army',
    //   name: 'souledarmy',
    //   component: () => import(/* webpackChunkName: "souledarmy" */ '@/components/souledarmy')
    // },
    {
      path: '/schools-and-colleges',
      name: 'schoolcolleges',
      component: () => import(/* webpackChunkName: "schoolcolleges" */ '@/components/schoolcolleges')
    },
    {
      path: '/contact-us',
      name: 'contact',
      component: () => import(/* webpackChunkName: "UltimateTee" */ '@/components/contact'),
      meta: {requiresAuth: true}
    },
    {
      path: '/the-ultimate-tee',
      name: 'UltimateTee',
      component: () => import(/* webpackChunkName: "UltimateTee" */ '@/components/ultimateTee')
    },
    {
      path: '/bulk-and-custom-orders',
      name: 'bulkcustomerorder',
      beforeEnter () { location.href = 'https://bulkorders.thesouledstore.com/' }
    },
    {
      path: '/early-access',
      name: 'earlyAccess',
      component: () => import(/* webpackChunkName: "earlyAccess" */ '@/components/earlyAccess')
    },
    {
      path: '/careers',
      name: 'careers',
      component: () => import(/* webpackChunkName: "careers" */ '@/components/careers')
    },

    // {
    //   path: '/submission-guidelines/:option',
    //   name: 'submissionguidelines',
    //   component: () => import(/* webpackChunkName: "submisionguidelines" */ '@/components/submisionguidelines')
    // },
    // {
    //   path: '/submit-art-work',
    //   name: 'submit-art-work',
    //   component: () => import(/* webpackChunkName: "submitartwork" */ '@/components/submitartwork')
    // },
    {
      path: '/cart/:odid?',
      name: 'cart',
      component: () => import(/* webpackChunkName: "cart" */ '@/components/cart')
    },
    {
      path: '/shipment/:odid?',
      name: 'shipment',
      component: () => import(/* webpackChunkName: "shipment" */ '@/components/cart'),
      beforeEnter: (to, from, next) => {
        if (isSelectedCountryGlobal) {
          next({
            path: '/'
          })
        } else {
          next()
        }
      }
    },
    {
      path: '/product/:pname',
      name: 'productdetails',
      component: () => import(/* webpackChunkName: "productdetails" */ '@/components/productdetails'),
      beforeEnter: (to, from, next) => {
        store.state.tagManager.productDetailsPrevRoute = from
        next()
      }
    },
    {
      path: '/artwork-sale',
      name: 'myartworksale',
      component: () => import(/* webpackChunkName: "myartworksale" */ '@/components/my-artwork-sale'),
      meta: { requiresAuth: true }
    },
    {
      path: '/login',
      name: 'login',
      component: function (resolve) {
        require(['@/components/auth.vue'], resolve)
      }
      // meta: { requiresAuth: false }
    },
    {
      path: '/register',
      name: 'register',
      component: function (resolve) {
        require(['@/components/auth.vue'], resolve)
      }
    },
    {
      path: '/profile',
      name: 'myprofile',
      component: function (resolve) {
        require(['@/components/myprofile.vue'], resolve)
      },
      meta: {requiresAuth: true}
    },
    {
      path: '/my-gift-voucher',
      name: 'mygiftvoucher',
      component: () => import(/* webpackChunkName: "mygiftvoucher" */ '@/components/mygiftvoucher'),
      meta: {requiresAuth: true},
      beforeEnter: (to, from, next) => {
        if (isSelectedCountryGlobal) {
          next({
            path: '/'
          })
        } else {
          next()
        }
      }
    },
    {
      path: '/my-reward-points/money',
      name: 'myrewardpointsMoney',
      component: function (resolve) {
        require(['@/components/myrewardpointsMoney.vue'], resolve)
      },
      meta: {requiresAuth: true},
      beforeEnter: (to, from, next) => {
        if (isSelectedCountryGlobal) {
          next({
            path: '/'
          })
        } else {
          next()
        }
      }
    },
    {
      path: '/my-reward-points/points',
      name: 'myrewardpointsTss',
      component: function (resolve) {
        require(['@/components/myrewardpointsTss.vue'], resolve)
      },
      meta: {requiresAuth: true},
      beforeEnter: (to, from, next) => {
        if (isSelectedCountryGlobal) {
          next({
            path: '/'
          })
        } else {
          next()
        }
      }
    },
    {
      path: '/my-saved-cards',
      name: 'mySavedCards',
      component: function (resolve) {
        require(['@/components/mySavedCards.vue'], resolve)
      },
      meta: {requiresAuth: true},
      beforeEnter: (to, from, next) => {
        if (isSelectedCountryGlobal) {
          next({
            path: '/'
          })
        } else {
          next()
        }
      }
    },
    {
      path: '/order/cancel/:orderId',
      name: 'cancelorder',
      component: () => import(/* webpackChunkName: "cancelorder" */ '@/components/cancelorder'),
      meta: {requiresAuth: true}
    },
    {
      path: '/order/exchange/:orderId',
      name: 'exchangeOrder',
      component: () => import(/* webpackChunkName: "exchangeorder" */ '@/components/exchangeOrder'),
      meta: {requiresAuth: true}
    },
    {
      path: '/order/return/:orderId',
      name: 'returnOrder',
      component: () => import(/* webpackChunkName: "returnOrder" */ '@/components/return/returnOrder'),
      meta: {requiresAuth: true}
    },
    {
      path: '/order/track/:ordId/:ordtype',
      name: 'trackorder',
      component: () => import(/* webpackChunkName: "trackorder" */ '@/components/trackorder')
    },
    {
      path: '/profile-address',
      name: 'profileaddress',
      component: () => import(/* webpackChunkName: "changeAddress" */ '@/components/profileAddress')
    },
    {
      path: '/view-invoice/:oid',
      name: 'viewinvoice',
      component: () => import(/* webpackChunkName: "viewInvoice" */ '@/components/viewInvoice'),
      meta: {requiresAuth: true}
    },
    {
      path: '/orders',
      name: 'myorders',
      component: function (resolve) {
        require(['@/components/myorders.vue'], resolve)
      },
      meta: {requiresAuth: true}
    },
    {
      path: '/thank-you',
      name: 'thankyou',
      component: () => import(/* webpackChunkName: "thankyou" */ '@/components/thankyou'),
      meta: {requiresAuth: true}
    },
    {
      path: '/failure',
      name: 'failure',
      component: () => import(/* webpackChunkName: "failure" */ '@/components/failure')
    },
    {
      path: '/delivery-address',
      name: 'deliveryaddress',
      component: () => import(/* webpackChunkName: "deliveryAddress" */ '@/components/deliveryAddress'),
      meta: {requiresAuth: true}
    },
    {
      path: '/add-address',
      name: 'addAddress',
      component: () => import(/* webpackChunkName: "deliveryAddress" */ '@/components/common/editAddAddressScreen'),
      meta: {requiresAuth: true}
    },
    {
      path: '/edit-address/:addId',
      name: 'editAddress',
      component: () => import(/* webpackChunkName: "deliveryAddress" */ '@/components/common/editAddAddressScreen'),
      meta: {requiresAuth: true}
    },
    {
      path: '/checkout',
      name: 'paymentoptions',
      component: () => import(/* webpackChunkName: "paymentOptions" */ '@/components/paymentOptions'),
      props: true,
      meta: {requiresAuth: true}
    },
    {
      path: '/error',
      name: 'error',
      component: () => import(/* webpackChunkName: "error" */ '@/components/error')
    },
    {
      path: '/notfound',
      name: 'notfound',
      component: () => import(/* webpackChunkName: "notFound" */ '../components/common/NoProductsFound')
    },
    {
      path: '/rosesarered',
      name: 'rosesarered',
      component: () => import(/* webpackChunkName: "RosesAreRed" */ '@/components/RosesAreRed')
    },
    {
      path: '/rosesarered/supporters',
      name: 'rosesarered-supporters',
      component: () => import(/* webpackChunkName: "RosesAreRedSupporter" */ '@/components/RosesAreRedSupporter')
    },
    {
      path: '/rosesarered/about',
      name: 'about-rosesarered',
      component: () => import(/* webpackChunkName: "AboutRosesAreRed" */ '@/components/AboutRosesAreRed')
    },
    {
      path: '/forgotpassword',
      name: 'forgotpassword',
      component: () => import(/* webpackChunkName: "forgot-password" */ '@/components/forgotpassword')
    },
    /* {
      path: '/:type/:sid',
      name: 'listing',
      component: Listing,
      props: (route) => ({query: route.query.page})
    }, */
    {
      path: '/membership',
      name: 'exclusive',
      component: () => import(/* webpackChunkName: "Exclusive" */ '@/components/exclusive')
    },
    {
      path: '/pause-for-paws',
      name: 'pauseForPaws',
      component: () => import(/* webpackChunkName: "PauseForPaws" */ '@/components/PauseForPaws/pauseForPaws')
    },
    {
      path: '/supima-landing/:gender',
      name: 'supimaLandingPage',
      component: () => import(/* webpackChunkName: "SupimaLanding" */ '@/components/SupimaLandingPage')
    },
    {
      path: '/active-wear-landing/:gender',
      name: 'activeWearLandingPage',
      component: () => import(/* webpackChunkName: "ActiveWearLanding" */ '@/components/ActiveWearLandingPage')
    },
    {
      path: '/winter-wear-landing/:gender',
      name: 'winterWearLandingPage',
      component: () => import(/* webpackChunkName: "ActiveWearLanding" */ '@/components/winterCollection/WinterWearLandingPage')
    },
    {
      path: '/contest-terms-and-conditions',
      name: 'contest-terms-conditions',
      component: () => import(/* webpackChunkName: "contestTermsConditions" */ '@/components/common/contestTermsConditions')
    },
    {
      path: '/autocomplete',
      name: 'autocomplete',
      component: () => import(/* webpackChunkName: "autocomplete" */ '@/components/common/autocomplete')
    },
    {
      path: '/dress-for-change',
      name: 'goonj',
      component: () => import(/* webpackChunkName: "Goonj" */ '@/components/goonj')
    },
    {
      path: '/the-responsible-mask',
      name: 'responsibleMask',
      component: () => import(/* webpackChunkName: "responsibleMask" */ '@/components/responsibleMask')
    },
    {
      path: '/HardikXTeachForIndia',
      name: 'feedTheSoul',
      component: () => import(/* webpackChunkName: "feedTheSoul" */ '@/components/feedTheSoul')
    },
    {
      path: '/savetheirsouls',
      name: 'wildLifeSOS',
      component: () => import(/* webpackChunkName: "wildLifeSOS" */ '@/components/wildLifeSOS')
    },
    {
      path: '/my-account',
      name: 'myAccount',
      component: () => import(/* webpackChunkName: "MyAccount" */ '@/components/MyAccount'),
      meta: {requiresAuth: true}
    },
    {
      path: '/track-my-order',
      name: 'trackmyorders',
      component: () => import(/* webpackChunkName: "TrackMyOrder" */ '@/components/TrackMyOrder'),
      meta: {requiresAuth: true}
    },
    {
      path: '/from-the-soul',
      name: 'campaignTSS',
      component: () => import(/* webpackChunkName: "CampaignUI" */ '@/components/campaignUI/campaignui')
    },
    {
      path: '/winterwear-collection',
      name: 'WinterCollectionHome',
      component: () => import(/* webpackChunkName: "CatCollectionHome" */ '@/components/SummerCollection/SummerCollectionHome')
    },
    {
      path: '/men-winterwear',
      name: 'WinterCollectionPage',
      component: () => import(/* webpackChunkName: "CatCollectionPage" */ '@/components/SummerCollection/SummerCollectionPage')
    },
    {
      path: '/verify-email',
      name: 'verifyEmail',
      component: () => import(/* webpackChunkName: "verifyEmail" */ '@/components/verifyEmail')
    },
    {
      path: '/filter-landing/:slug',
      name: 'filterlanding',
      component: () => import(/* webpackChunkName: "productdetails" */ '@/components/filterlanding')
    },
    {
      path: '/women-winterwear',
      name: 'WinterCollectionPage',
      component: () => import(/* webpackChunkName: "CatCollectionPage" */ '@/components/SummerCollection/SummerCollectionPage')
    },
    {
      path: '/stay-at-home',
      name: 'StayAtHomeLandingPage',
      component: () => import(/* webpackChunkName: "StayAtHome" */ '@/components/StayAtHomeLandingPage')
    },
    {
      path: '/mywishlist',
      name: 'mywishlist',
      component: () => import(/* webpackChunkName: "Wishlist" */ '@/components/mywishlist')
    },
    {
      path: '/care-page/sneaker_page',
      name: 'sneakercare',
      component: () => import(/* webpackChunkName: "Sneakercare" */ '@/components/sneakercarehome')
    },
    {
      path: '/care-detail-page/sneaker_page/:id',
      name: 'sneakercaredetail',
      component: () => import(/* webpackChunkName: "Sneakercare" */ '@/components/sneakercaredetail')
    },
    {
      path: '/shop-the-look',
      name: 'shopTheLook',
      component: () => import(/* webpackChunkName: "ShopTheLook" */ '@/components/ShopTheLook')
    },
    {
      path: '/email-shop-now',
      name: 'emailShopNowRedirection',
      component: () => import(/* webpackChunkName: "emailShopNowRedirection" */ '@/components/emailShopNowRedirection.vue')
    },
    {
      path: '/wwe',
      beforeEnter () { location.href = '/' },
      name: 'wwe'
    },
    {
      path: '/metaverse',
      name: 'metaverseLanding',
      component: () => import(/* webpackChunkName: "metaverseLanding" */ '@/components/metaverse/metaverseLanding.vue')
    },
    {
      path: '/categories',
      name: 'categories',
      component: () => import(/* webpackChunkName: "categories" */ '@/components/categories')
    },
    {
      path: '/codcheckout',
      name: 'codcheckout',
      component: () => import(/* webpackChunkName: "codCheckout" */ '@/components/codCheckout.vue')
    },
    {
      path: '*',
      component: () => import(/* webpackChunkName: "noProductFound" */ '../components/common/NoProductsFound')
    },
    {
      path: '/:type?/:sid',
      name: 'listing',
      component: () => import(/* webpackChunkName: "listing" */ '@/components/listing.vue'),
      props: route => ({
        query: route.query.page,
        type: route.params.type || null,
        sid: route.params.sid
      })
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      // If the route has a hash (sectional link), scroll to the element with the corresponding ID.
      return {
        selector: to.hash,
        offset: { x: 0, y: 100 } // Adjust the offset as needed to accommodate any fixed headers or margins.
      }
    } else if (from.path === to.path && to.name === 'listing') {
      return {}
    }
    return {x: 0, y: 0}
  }
})

router.beforeEach((to, from, next) => {
  // const currentHostname = window.location.hostname
  if (to.path === '/pos/login/' && to.query.api_key === process.env.POS_LOGIN_API_KEY && to.query.token) {
    Vue.ls.set('tss_token', to.query.token)
    Vue.ls.set('pos_login', true)
    Vue.ls.set('pos_store_id', to.query.pos_store_id)
    Vue.ls.set('pos_user_id', to.query.pos_user_id)
    next({
      path: '/'
    })
  }
  if (to.path === '/codcheckout' && to.query.token) {
    Vue.ls.set('tss_token', to.query.token)
    Vue.ls.set('cod_checkout_login', true)
  }
  if ((from.name === 'listing' && to.name === 'listing') || (from.name === 'search' && to.name === 'search')) {
    Vue.ls.set('routeObj', {
      current: getLastPage(to.name),
      previous: Vue.ls.get('routeObj').previous || ''
    })
  } else if (to.name === 'cancelorder') {
    Vue.ls.set('routeObj', {
      current: Vue.ls.get('routeObj').current,
      previous: Vue.ls.get('routeObj').previous || ''
    })
  } else if (to.name === 'order') {
    Vue.ls.set('routeObj', {
      current: Vue.ls.get('routeObj').current,
      previous: Vue.ls.get('routeObj').previous || ''
    })
  } else {
    Vue.ls.set('routeObj', {
      current: getLastPage(to.name),
      previous: getLastPage(from.name) || ''
    })
  }
  const Datetiming = new Date()
  store && store.getters && store.getters.userInterestTime ? '' : store.commit('USER_INTEREST_TIME', Datetiming.getTime())
  if (to.path === '/login') {
    store.dispatch('CHECK_AUTH')
    if (store.getters.authStatus) {
      next({
        path: '/'
      })
    } else {
      next()
    }
  } else if (from.path === '/thank-you' && to.path === '/checkout') {
    next({
      path: '/'
    })
  } else if (to.path && to.path.includes('/tags/') && nginxTags && !nginxTags.includes(to.path) && to.params && to.params.sid) {
    if (to.query) {
      let params
      params = to.query
      next({
        path: `/${to.params.sid}`, query: params
      })
    } else {
      next({
        path: `/${to.params.sid}`
      })
    }
  } else if (to.matched.some(record => record.meta.requiresAuth)) {
    store.dispatch('CHECK_AUTH')
    if (!store.getters.authStatus) {
      next({
        path: '/login',
        query: {redirect: to.fullPath}
      })
    } else {
      next()
    }
  } else if (to.path && to.path.includes('///')) {
    next({
      path: '/notfound'
    })
  } else {
    next() // make sure to always call next()!
  }
})

router.afterEach((to, from) => {
  Vue.nextTick(() => {
    if (to.fullPath !== from.fullPath) {
      setTimeout(() => {
        store.commit('GTM_EVENT', {
          eventName: 'page_view_new',
          payload: {
            page_title: document.title,
            page_location: window.location.href,
            page_path: window.location.pathname
          }}
        )
      }, 2000)
    }
  })
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js